import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Alert } from '../Alert';
import { Box } from '../Box';
export const SnackbarErrorContent = /*#__PURE__*/ React.forwardRef(function SnackbarErrorContent({ id, title, subtitle, details, severity, closeSnackbar, ...otherProps }, ref) {
    return /*#__PURE__*/ _jsx(Alert, {
        ref: ref,
        ...otherProps,
        severity: severity,
        onClose: ()=>closeSnackbar(id),
        "aria-describedby": "snackbar-err-content",
        sx: {
            minWidth: 300
        },
        Header: /*#__PURE__*/ _jsx("div", {
            id: "snackbar-err-content",
            children: title
        }),
        MoreDetails: details ? /*#__PURE__*/ _jsx(_Fragment, {
            children: details.map((msg, idx)=>/*#__PURE__*/ _jsx(Box, {
                    children: msg
                }, idx))
        }) : undefined,
        children: subtitle
    });
});

//# sourceMappingURL=SnackbarErrorContent.js.map